import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Settings, UserCog, MoonStar, ShieldCheck, ClipboardList, ChevronDown, Mail, MessageSquareQuote, Building2 } from "lucide-react";
import { Button } from "@/components/ui/button";
import { DropdownMenu, DropdownMenuContent, DropdownMenuItem, DropdownMenuSeparator, DropdownMenuTrigger } from "@/components/ui/dropdown-menu";
import AdminsDialog from "@/components/AdminsDialog";
import QuietHoursDialog from "@/components/QuietHoursDialog";
import PrivacySettingsDialog from "@/components/PrivacySettingsDialog";
import EmailPreviewDialog from "@/components/EmailPreviewDialog";

const Item = ({ icon: Icon, label, testId, onSelect }) => (
  <DropdownMenuItem onSelect={onSelect} className="gap-2 cursor-pointer" data-testid={testId}><Icon className="h-4 w-4" /> {label}</DropdownMenuItem>
);

export default function SettingsMenu({ isAdmin, canAudit }) {
  const navigate = useNavigate();
  const [dialog, setDialog] = useState(null);
  if (!isAdmin && !canAudit) return null;
  const hidden = <button type="button" className="hidden" aria-hidden="true" />;
  return (
    <>
      <DropdownMenu>
        <DropdownMenuTrigger asChild>
          <Button variant="outline" className="gap-2 border-border" data-testid="open-settings-menu"><Settings className="h-4 w-4" /> Impostazioni <ChevronDown className="h-3.5 w-3.5 opacity-60" /></Button>
        </DropdownMenuTrigger>
        <DropdownMenuContent align="end" className="w-56" data-testid="settings-menu">
          {isAdmin && <Item icon={UserCog} label="Admin e operatori" testId="open-admins-button" onSelect={() => setDialog("admins")} />}
          {isAdmin && <Item icon={MoonStar} label="Fascia notturna" testId="open-quiet-hours-button" onSelect={() => setDialog("quiet")} />}
          {isAdmin && <Item icon={ShieldCheck} label="Privacy generale" testId="open-privacy-settings-button" onSelect={() => setDialog("privacy")} />}
          {isAdmin && <Item icon={Mail} label="Anteprima email" testId="open-email-preview-button" onSelect={() => setDialog("email")} />}
          {isAdmin && <Item icon={MessageSquareQuote} label="Testimonianze home" testId="open-testimonials-button" onSelect={() => navigate("/testimonianze")} />}
          {isAdmin && <Item icon={Building2} label="Contatti Studio Nouvelle" testId="open-studio-button" onSelect={() => navigate("/contatti-studio")} />}
          {isAdmin && canAudit && <DropdownMenuSeparator />}
          {canAudit && <Item icon={ClipboardList} label="Log Attività" testId="open-audit-button" onSelect={() => navigate("/log-attivita")} />}
        </DropdownMenuContent>
      </DropdownMenu>
      {dialog === "admins" && <AdminsDialog trigger={hidden} defaultOpen onClosed={() => setDialog(null)} />}
      {dialog === "quiet" && <QuietHoursDialog trigger={hidden} defaultOpen onClosed={() => setDialog(null)} />}
      {dialog === "privacy" && <PrivacySettingsDialog trigger={hidden} defaultOpen onClosed={() => setDialog(null)} />}
      {dialog === "email" && <EmailPreviewDialog trigger={hidden} defaultOpen onClosed={() => setDialog(null)} />}
    </>
  );
}
